import React, { useState } from "react";
import { Outlet, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PublicNavbar from "../components/PublicNavbar";
import PublicFooter from "../components/PublicFooter";
import ScrollToTop from "../components/ScrollToTop";
import allRoutes from "client/constants/allRoutes";
import "../css/style.css";
import "../css/animations.css";
import "../css/components.css";
import "../marketing.css";

const HelpFloat = () => {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (location.pathname === "/") {
      const el = document.getElementById("contact");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    navigate("/contact");
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="help-float-btn"
      aria-label="Help"
    >
      <svg className="h-6 w-6 text-white flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm0 14H5.17L4 17.17V4h16v12Z" />
        <circle cx="12" cy="10" r="1.2" />
        <circle cx="8" cy="10" r="1.2" />
        <circle cx="16" cy="10" r="1.2" />
      </svg>
      <span
        className="help-float-label"
        style={{
          maxWidth: hovered ? "120px" : "0px",
          opacity: hovered ? 1 : 0,
          marginLeft: hovered ? "8px" : "0px",
        }}
      >
        Need Help?
      </span>
    </button>
  );
};

const PublicLayout = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={allRoutes.portal} replace />;
  }

  return (
    <div className="theme-light min-h-screen flex flex-col font-body" style={{ background: '#ffffff', color: '#0b1220' }}>
      <ScrollToTop />
      <PublicNavbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
      <HelpFloat />
    </div>
  );
};

export default PublicLayout;
